import React from 'react';
import { ActionIcon, useMantineColorScheme, Text, useMantineTheme, Menu, Group, Box } from '@mantine/core';
import { IconSun, IconMoonStars, IconUser } from '@tabler/icons-react';

import { useLoginContextSU } from "../context/loginContextSU";

import { safetyDecodeJWT, getPropInSubLevelJWT } from "../utils/globalFunctions";

import ModalTakeAction from "../components/general/ModalTakeAction";

const Toggler = () => {

    const theme = useMantineTheme();
    const { colorScheme, toggleColorScheme } = useMantineColorScheme();
    const light = colorScheme === 'light';

    return (
        <React.Fragment>
            <ActionIcon
                variant='subtle'
                radius='xl'
                size='lg'
                sx={{
                    border: 0,
                    color: theme.colorScheme === 'light' ? theme.colors.gray[9] : theme.colors.gray[2]
                }}
                onClick={() => toggleColorScheme()}
                title={light ? 'Mode Gelap' : 'Mode Terang'}
            >
                {light ?
                    <IconMoonStars
                        size={20}
                        strokeWidth={1.5}
                    />
                    :
                    <IconSun
                        size={24}
                        strokeWidth={1.5}
                    />}
            </ActionIcon>
        </React.Fragment>
    )
}

const HeaderNavSU = () => {

    const theme = useMantineTheme();
    // const { subMenu } = useParams();
    const { loginContextSU, handleSetLoginContextSU } = useLoginContextSU();

    const [data, setData] = React.useState({
        modalSignOut: false
    })

    return (
        <React.Fragment>
            <Group
                className='headerNavComponent'
                position='apart'
                noWrap={true}
                spacing='xs'

                py='md'
                px='md'
            >
                <Group noWrap={true}>
                    <Text lineClamp={1} tt='uppercase' sx={{ fontWeight: '500', fontSize: theme.fontSizes.lg }}>
                        Super User{/* {menuListSU.subMenu.one.name} */}
                    </Text>
                </Group>

                <Group spacing='sm' noWrap={true}>
                    <Toggler />

                    <Menu
                        shadow="md"
                        width={250}
                    >
                        <Menu.Target>
                            <ActionIcon
                                variant='subtle'
                                radius='xl'
                                size='lg'
                                sx={{
                                    border: 0,
                                    color: theme.colorScheme === 'light' ? theme.colors.gray[9] : theme.colors.gray[2]
                                }}
                                title={'Settings'}
                            >
                                <IconUser
                                    size={22}
                                    strokeWidth={1.5}
                                />
                            </ActionIcon>
                        </Menu.Target>

                        <Menu.Dropdown>
                            <Menu.Label>
                                <Text
                                    sx={(tema) => ({
                                        color: tema.colorScheme === 'light' ? tema.colors.dark[9] : tema.colors.dark[0]
                                    })}
                                >
                                    <Text
                                        size='sm'
                                    >
                                        {safetyDecodeJWT(loginContextSU, 'syswebapp', 'syswebappn')}
                                    </Text>

                                    <Text>
                                        {getPropInSubLevelJWT(loginContextSU, 'caption', '')}
                                    </Text>

                                    <Box
                                        mt='md'
                                    >
                                        <Text
                                            size='sm'
                                            tt='uppercase'

                                            sx={(tema) => ({
                                                display: 'inline',
                                                cursor: 'pointer',
                                                color: tema.colorScheme === 'light' ? tema.colors.blue[5] : tema.colors.blue[3],

                                                '&:hover': {
                                                    color: tema.colorScheme === 'light' ? tema.colors.blue[3] : tema.colors.blue[4],
                                                }
                                            })}

                                            onClick={() => setData(d => ({ ...d, modalSignOut: true }))}
                                        >
                                            Sign Out
                                        </Text>
                                    </Box>
                                </Text>
                            </Menu.Label>
                        </Menu.Dropdown>
                    </Menu>
                </Group>
            </Group>

            <ModalTakeAction
                stateShow={data.modalSignOut}
                fnHide={() => setData(d => ({ ...d, modalSignOut: false }))}
                stateTitle='Confirmation'
                stateButtonActionCaption='Sign Out'
                fnButtonAction={() => handleSetLoginContextSU(null)}
                stateButtonActionLoading={false}
            >
                Sign Out ?
            </ModalTakeAction>
        </React.Fragment>
    )
}

export default HeaderNavSU;